import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, auth } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const token = params.get("token");
    const error = params.get("error");
    if (error) {
      toast.error("Discord login failed: " + error);
      navigate("/");
      return;
    }
    if (!token) {
      navigate("/");
      return;
    }
    (async () => {
      localStorage.setItem("606_token", token);
      try {
        const { data } = await api.get("/auth/me");
        const u = {
          id: data.user.sub,
          username: data.user.username,
          avatar: data.user.avatar,
          is_demo: data.user.is_demo,
        };
        localStorage.setItem("606_user", JSON.stringify(u));
        toast.success(`Welcome ${u.username}`);
        navigate("/dashboard");
      } catch {
        auth.clear();
        toast.error("Session error");
        navigate("/");
      }
    })();
  }, [params, navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-black flex items-center justify-center">
      <div className="font-mono-tabular text-brand-orange text-sm tracking-widest uppercase">
        AUTHENTICATING…
      </div>
    </div>
  );
}
